<template>
  <v-dialog
    :value="opened"
    @input="onCloseDialog"
    max-width="1031px"
    scrollable
  >
    <v-card>
      <v-card-text>
        <v-container>
          <v-data-table
            :headers="headers"
            :items="foundInterestsSuggestions"
            item-key="id"
          >
            <template #item.audience_size="{ item }">
              {{ item.audienceSize ? item.audienceSize.toLocaleString() : "" }}
            </template>

            <template #item.path="{ item }">
              {{ item.path ? item.path.join(" > ") : "" }}
            </template>

            <template #item.actions="{ item }">
              <template v-if="!interestIsSelected(item)">
                <v-btn @click="interestAdd(item)" text small class="clr-black">
                  <img
                    class="mr-2"
                    :src="require('@/assets/ico-add.svg')"
                    alt=""
                  />
                  Přidat
                </v-btn>
              </template>

              <template v-else>
                <v-btn
                  @click="interestRemove(item)"
                  text
                  small
                  class="clr-black"
                >
                  <img
                    class="mr-2"
                    :src="require('@/assets/ico-minus.svg')"
                    alt=""
                  />
                  Odebrat
                </v-btn>
              </template>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions class="c-dialog__footer d-block">
        <v-container v-if="selectedInterests.length > 0" class="px-6 pb-0">
          <div class="mb-4 mx-n1">
            <v-chip
              v-for="interest in selectedInterests"
              :key="interest.id"
              color="#d7d7e2"
              text-color="#595285"
              class="font-weight-bold mx-1"
              close
              @click:close="interestRemove(interest)"
            >
              {{ interest.name }}
            </v-chip>
          </div>

          <v-divider />
        </v-container>

        <v-container class="d-flex justify-space-between px-6">
          <v-btn text @click="close">
            Zavřít
          </v-btn>
          <v-btn
            class="ml-auto"
            color="primary"
            :disabled="!saveBtnEnabled"
            @click="onSaveBtnClick"
          >
            Uložit
          </v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { call, get } from "vuex-pathify"

import { arrayJoinByKey } from "@/helpers/arrays"

const headers = [
  { text: "Zájem", align: "start", value: "name", sortable: false },
  { text: "Velikost publika", value: "audience_size", sortable: false },
  { text: "Cesta", value: "path", sortable: false },
  { text: "", value: "actions", sortable: false },
]

export default {
  name: "TargetingSuggestionsModal",
  props: {
    sourceData: {
      type: Array,
      required: true,
    },
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers,
      query: null,
      selectedInterests: [],
    }
  },
  computed: {
    ...get("targeting", ["foundInterestsSuggestions", "searching"]),
    saveBtnEnabled() {
      return this.selectedInterests.length > 0
    },
    searchBtnEnabled() {
      return !!this.query && this.query.length > 1
    },
  },
  methods: {
    ...call("targeting", [
      "clearFoundInterestsSuggestions",
      "searchInterestsSuggestions",
    ]),
    clearDialog() {
      this.clearFoundInterestsSuggestions()
      this.query = null
      this.selectedInterests = []
    },
    close() {
      this.$emit("update:opened", false)
    },
    interestAdd(interest) {
      this.selectedInterests.push(interest)
    },
    interestIsSelected(interest) {
      return this.selectedInterests.some(i => i.id === interest.id)
    },
    interestRemove(interest) {
      this.selectedInterests = this.selectedInterests.filter(
        i => i.id !== interest.id
      )
    },
    onCloseDialog(value) {
      this.clearDialog()
      this.$emit("update:opened", value)
    },
    onSaveBtnClick() {
      this.$emit("update:opened", false)
      this.$emit("save", this.selectedInterests)
    },
    onSearchBtnClick() {
      this.searchInterests(this.query)
    },
  },
  watch: {
    opened(val) {
      if (val) {
        this.searchInterestsSuggestions(this.sourceData)
      }
    },
  },
}
</script>
